module.exports = __webpack_public_path__ + "img/cards.695588b3.svg";